// rkey generation. The three record collections use `key: "tid"` (§4.1–§4.3), so rkeys MUST be
// valid, monotonic TIDs. Delegates to @atproto/common-web's battle-tested generator; `genTid` is
// injectable throughout the publish path so tests can supply deterministic keys.
import { TID } from "@atproto/common-web";

/** Generate a fresh, monotonic TID string suitable for a record rkey. Uses the wall clock. */
export function nextTid(): string {
  return TID.nextStr();
}
